export const common: any = {
  total: "Total",
  loading: "Loading",
  clickToSelect: "Click to select",
  others: "Others",
  viewLargerMap: "View larger map",
};
